PLAN_TRIAL_PERIOD_FOURTEEN_DAYS